<template>
  <div>
    <!-- header -->
    <div class="fd-head">
      <div class="select-wp">
        <div class="select-box" style="width: 200px">
          <select id="sel_semester" name="">
            <option
              :value="item.Id"
              v-for="(item, idx) in semesterList"
              :key="idx"
            >
              {{ item.Name }} 学期
            </option>
          </select>
        </div>
      </div>
      <h3>企业经济活动国家级虚拟仿真实验教学示范中心</h3>
      <h4>实验室运行管理数据面板</h4>
      <!-- 链接 -->
      <div class="page-fl">
        <router-link :to="'/'">
          <div class="fd-weekbutton">
            <span class="fd-week-ico fd-weekfl"></span>
            <span class="fd-weektext">上一页</span>
          </div>
        </router-link>
      </div>
      <div class="page-fr">
        <router-link :to="'/data3'">
          <div class="fd-weekbutton">
            <span class="fd-weektext">下一页</span>
            <span class="fd-week-ico fd-weekfr"></span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- fl-->
    <div class="fd-fl" style="width: 38%">
      <!-- 图1 -->
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">本学期周数数据</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="fd-data fd-data-small">
            <ul>
              <li>
                <span class="fd-data-ico fd-data-course"></span>
                <span class="fd-data-name">累计课程数量</span>
                <span class="fd-data-num">{{ statModel.totalCourseNum }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-time"></span>
                <span class="fd-data-name">累计实验时数</span>
                <span class="fd-data-num">{{ statModel.totalHours }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-people"></span>
                <span class="fd-data-name">累计实验人数</span>
                <span class="fd-data-num">{{ statModel.totalNumber }}</span>
              </li>
            </ul>
          </div>
          <div id="fd-pie1" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <!-- 图2 -->
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">本学期实验室数据</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div id="fd-pie2" style="width: 100%; height: 288px"></div>
        </div>
      </div>
    </div>
    <!-- fr -->
    <div class="fd-fr" style="width: 59%; margin-right: 20px">
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">实验室运行情况</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="fd-data fd-data-small">
            <ul>
              <li>
                <span class="fd-data-ico fd-data-course"></span>
                <span class="fd-data-name">当日课程数量</span>
                <span class="fd-data-num">{{ statModel.todayCourseNum }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-time"></span>
                <span class="fd-data-name">当日实验时数</span>
                <span class="fd-data-num">{{ statModel.todayHours }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-people"></span>
                <span class="fd-data-name">当日实验人数</span>
                <span class="fd-data-num">{{ statModel.todayNumber }}</span>
              </li>
            </ul>
          </div>
          <!-- 实验室状态 -->
          <div class="fd-lab-box">
            <h3>
              <span>各实验室实时状态</span>（点击卡片可查看当前实验室详情）
            </h3>
            <ul>
              <li v-for="(item, index) in laboratoryList" :key="index">
                <a
                  href="javascript:;"
                  data-width="1068px"
                  data-height="690px"
                  :rel="'#/details/' + item.Id"
                  class="showbtn"
                >
                  <div class="fd-lab-tit">
                    <span class="fd-lab-ico"></span>
                    <span class="fd-lab-name"
                      ><i>{{ item.RoomCode }}</i
                      >{{ item.Name }}</span
                    >
                    <div
                      class="fr"
                      v-for="(label, idx) in item.labels"
                      :key="idx"
                    >
                      <i :class="'fd-lab-sign ' + labelColor[idx]">{{
                        label
                      }}</i>
                    </div>
                  </div>
                  <div class="fd-lab-state-box">
                    <div class="fd-lab-state">
                      <span
                        class="fd-lab-state-tit green"
                        v-if="item.Status == 1"
                        >上课中</span
                      >
                      <span class="fd-lab-state-tit blue" v-else>空闲</span>
                      <span class="fd-lab-state-sm">运行状态</span>
                    </div>
                    <div class="fd-lab-state-line"></div>
                    <div class="fd-lab-state">
                      <span
                        class="fd-lab-state-tit green"
                        v-if="item.IsOpen && !item.IsAbnormal"
                        >已开门</span
                      >
                      <span
                        class="fd-lab-state-tit red"
                        v-if="item.IsOpen && item.IsAbnormal"
                        >待关门</span
                      >
                      <span
                        class="fd-lab-state-tit blue"
                        v-if="!item.IsOpen && !item.IsAbnormal"
                        >已关门</span
                      >
                      <span
                        class="fd-lab-state-tit red"
                        v-if="!item.IsOpen && item.IsAbnormal"
                        >未开门</span
                      >
                      <span class="fd-lab-state-sm">开门状态</span>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import $ from '../../static/js/jquery.min.js'
import layer from "../../static/layer/layer.js"
import echarts from 'echarts'
import {
  getApi
} from '../../static/js/api.js'
export default {
  data () {
    return {
      semesterId: 0,
      statModel: {
        totalCourseNum: 0,
        totalHours: 0,
        totalNumber: 0,
        weeks: [],
        laboratorys: [],
        todayCourseNum: 0,
        todayHours: 0,
        todayNumber: 0
      },
      laboratoryList: [],
      labelColor: ['bg-orange', 'bg-blue', 'bg-green', 'bg-gray', 'bg-white', 'bg-purple', 'bg-red'],
      semesterList: [],
      week: 0
    }
  },
  mounted () {
    this.getSemesterList()
    this.GetStatData()

    //获取实验室状态列表
    this.GetLaboratorys()
    //定时刷新实验室状态
    setInterval(this.GetLaboratorys, 5000)
  },
  methods: {
    getSemesterList () {
      let that = this
      getApi('/Semester/GetAll').then(res => {
        if (res.IsSuccess) {
          this.semesterList = res.SuccessData
          setTimeout(() => {
            $("select").selectOrDie()
            $("#sel_semester").change(function () {
              that.GetStatData($(this).find('option:selected').val())
            })
          }, 500)
        }
      })
    },
    GetStatData (semesterId) {
      if (!semesterId) {
        semesterId = 0
      }
      let that = this
      //获取当前学期
      getApi('/bi/GetNowSemesterAndWeek', { semesterId: semesterId }, 'Post').then(res => {
        if (res.IsSuccess) {
          that.semesterId = res.SuccessData.Semester.Id
          that.week = res.SuccessData.Week
        }
        getApi('/bi/GetBusinessCourseStat', {
          semesterId: that.semesterId
        }, 'Post').then(r => {
          that.statModel = r.SuccessData
        }).finally(() => {
          // 实验室年度数据
          let myChartPie1 = echarts.init(document.getElementById('fd-pie1'));
          let option1 = {
            tooltip: {
              trigger: 'axis',
            },
            grid: {
              right: '10%'
            },
            legend: {
              data: ['时数', '人数'],
              textStyle: {
                color: '#aaecff'
              }
            },
            xAxis: [{
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              data: that.statModel.weeks.map(v => v.week + '周')
            }],
            yAxis: [{
              type: 'value',
              name: '时数',
              min: 0,
              position: 'right',
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              splitLine: {
                lineStyle: {
                  color: '#1b3676'
                }
              },
              axisLabel: {
                formatter: '{value}'
              }
            },
            {
              type: 'value',
              name: '人数',
              min: 0,
              position: 'left',
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value}'
              }
            }
            ],
            series: [{
              name: '时数',
              type: 'bar',
              barWidth: '50%',
              itemStyle: {
                color: (p) => {
                  console.log(p)
                  if (p.name == (this.week + "周")) {
                    return new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [{
                        offset: 0.5,
                        color: '#FF0000'
                      },
                      {
                        offset: 1,
                        color: '#00FF00'
                      }
                      ]
                    )
                  } else {
                    return new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [{
                        offset: 0.5,
                        color: '#0084ff'
                      },
                      {
                        offset: 1,
                        color: '#02daff'
                      }
                      ]
                    )
                  }
                }
              },
              data: that.statModel.weeks.map(v => v.hours)
            },
            {
              name: '人数',
              type: 'line',
              symbol: 'circle',
              yAxisIndex: 1,
              itemStyle: {
                color: '#77ffff'

              },
              data: that.statModel.weeks.map(v => v.peopleNum)
            }
            ]
          };
          myChartPie1.setOption(option1, true);

          // 实验室累计时数
          let myChartPie2 = echarts.init(document.getElementById('fd-pie2'));
          let option2 = {
            tooltip: {
              trigger: 'axis',
            },
            grid: {
              right: '3%',
              bottom: '0',
              left: '6%'
            },
            grid: {
              right: '10%'
            },
            legend: {
              data: ['时数', '人数'],
              textStyle: {
                color: '#aaecff'
              }
            },
            xAxis: [{
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              data: that.statModel.laboratorys.map(v => v.roomCode)
            }],
            yAxis: [{
              type: 'value',
              name: '时数',
              min: 0,
              position: 'right',
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              splitLine: {
                lineStyle: {
                  color: '#1b3676'
                }
              },
              axisLabel: {
                formatter: '{value}'
              }
            },
            {
              type: 'value',
              name: '人数',
              min: 0,
              position: 'left',
              axisLine: {
                lineStyle: {
                  color: '#aaecff'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value}'
              }
            }
            ],
            series: [{
              name: '时数',
              type: 'bar',
              barWidth: '50%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                    offset: 0.5,
                    color: '#0084ff'
                  },
                  {
                    offset: 1,
                    color: '#02daff'
                  }
                  ]
                )
              },
              data: that.statModel.laboratorys.map(v => v.hours)
            },
            {
              name: '人数',
              type: 'line',
              symbol: 'circle',
              yAxisIndex: 1,
              itemStyle: {
                color: '#77ffff'

              },
              data: that.statModel.laboratorys.map(v => v.peopleNum)
            }
            ]
          };
          myChartPie2.setOption(option2, true);
        })
      })
    },
    GetLaboratorys () {
      let that = this
      Promise.all([
        getApi('/Laboratory/GetRunStatus', {}, 'Post').catch(() => null),
        getApi('/Laboratory/GetRunStatusList', {}, 'Post').catch(() => null)
      ]).then(([runRes, listRes]) => {
        const statusList = (runRes && runRes.IsSuccess && runRes.SuccessData && runRes.SuccessData.laboratoryStatus) || []
        const labelMap = {}
        if (listRes && listRes.IsSuccess && listRes.SuccessData) {
          listRes.SuccessData.forEach(item => {
            labelMap[item.Id] = item.labels || []
          })
        }
        that.laboratoryList = statusList.map(item => ({
          ...item,
          labels: labelMap[item.Id] || []
        }))
      }).finally(() => {
        // 弹框
        $('.showbtn').unbind();
        $('.showbtn').on('click', function () {
          console.log('showbtn')
          layer.open({
            type: 2,
            // maxmin: true,
            title: false,
            shadeClose: false,
            shade: 0.8,
            area: [$(this).attr("data-width"), $(this).attr("data-height")],
            content: $(this).attr("rel")
          });
        });
      })
    }
  }
}
</script>

<style>
@import url("../../static/layer/theme/default/layer.css");
</style>
